function Directive($compile, $timeout, $location, $sce) {
  return {
    restrict: 'E',
    scope: {
      src: '=',
      player: '=',
      height: '@',
      width: '@'
    },
    link(scope, element) {

      if (!scope.src) return;

      const options = '&auto_play=false&buying=false&liking=false&download=false&sharing=false&show_artwork=false&show_comments=false&show_playcount=false';

      scope.src = scope.src && scope.src.$$unwrapTrustedValue ? scope.src.$$unwrapTrustedValue() : scope.src;

      scope.src = $sce.trustAsResourceUrl(`${$location.protocol()}://w.soundcloud.com/player/?url=${scope.src}${options}`);

      scope.height = scope.height || '450px';
      scope.width = scope.width || '100%';

      const templateElement = '<iframe width="{{ width }}" height="{{ height }}" scrolling="no" ng-src="{{ src }}" frameborder="no"></iframe>';
      const compiledElement = $compile(templateElement)(scope);

      element.replaceWith(compiledElement);

      const widgetElement = compiledElement[0];

      $timeout(function() {
        scope.player = window.SC.Widget(widgetElement);
        scope.player.EVENTS = window.SC.Widget.Events;

        scope.player.on = function(eventName, eventHandler) {
          const newEventHandler = function(...args) {
            scope.$apply(function() {
              eventHandler.call(scope.player, args);
            });
          };

          scope.player.bind.call(scope.player, eventName, newEventHandler);
        };

        scope.player.bind(window.SC.Widget.Events.READY, function() {
          scope.$emit('SOUNDCLOUD_READY');
          scope.player.ready = true;
        });

        scope.player.bind(window.SC.Widget.Events.PLAY, function() {
          scope.$apply(function() {
            scope.player.playing = true;
          });
        });

        scope.player.bind(window.SC.Widget.Events.PAUSE, function() {
          scope.$apply(function() {
            scope.player.playing = false;
          });
        });

      }, 2000);
    }
  };
}

Directive.$inject = [
  '$compile',
  '$timeout',
  '$location',
  '$sce'
];

export default Directive;



// WEBPACK FOOTER //
// ./src/directives/soundcloudPlayer/index.js